import shouldHideFilterSectionInListingPage from "./shouldHideFilterSectionInListingPage";

const filtersToCount = [
  { internalName: "kinds", algoliaName: "segment" },
  { internalName: "category", algoliaName: "category" },
  { internalName: "colors", algoliaName: "colors" },
  { internalName: "seasons", algoliaName: "season" },
  { internalName: "sleeves", algoliaName: "sleeves" },
  { internalName: "legs", algoliaName: "legs" },
  { internalName: "brands", algoliaName: "brand.name" },
];

export default function computeAppliedFiltersCount(listingPage, refinementList, personalised) {
  let count = 0;

  filtersToCount.forEach((filter) => {
    if (shouldHideFilterSectionInListingPage(listingPage, filter.internalName)) return;
    if (refinementList?.[filter.algoliaName]?.includes("all")) return;

    const filterCount = refinementList?.[filter.algoliaName]?.length || 0;
    count += filterCount;
  });

  if (
    personalised !== "all" &&
    !shouldHideFilterSectionInListingPage(listingPage, "personalised")
  ) {
    count += 1;
  }

  return count;
}
